import React, { useState } from 'react';

const roleList = ['Owner', 'Team Admin', 'Member', 'View Only'];

function InviteTeamCard({ data, onFieldChange, onCardRemove, hideRemoveBtn }) {
  const [isDropdown, setIsDropdown] = useState(false);

  const handleSelectChange = (value) => {
    setIsDropdown(false);
    onFieldChange(data.id, 'role', value);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    onFieldChange(data.id, 'email', value);
  };

  return (
    <div className="group-input-invite-team">
      <div className="cover-input-invite-team">
        <div className="icon-input-invite-team">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.67906 6.81641H8.64859C7.99563 6.8164 7.46159 6.81639 7.0276 6.85185C6.57838 6.88855 6.17266 6.96684 5.79376 7.1599C5.20076 7.46205 4.71864 7.94417 4.41649 8.53716C4.22343 8.91606 4.14515 9.32178 4.10844 9.77101C4.07298 10.205 4.07299 10.739 4.073 11.392V11.4225V14.978V15.0085C4.07299 15.6615 4.07298 16.1955 4.10844 16.6295C4.14515 17.0787 4.22343 17.4844 4.41649 17.8633C4.71864 18.4563 5.20076 18.9384 5.79376 19.2406C6.17266 19.4336 6.57838 19.5119 7.0276 19.5486C7.4616 19.5841 7.99562 19.5841 8.64859 19.5841H8.67906H15.4669H15.4974C16.1504 19.5841 16.6844 19.5841 17.1184 19.5486C17.5676 19.5119 17.9733 19.4336 18.3522 19.2406C18.9452 18.9384 19.4274 18.4563 19.7295 17.8633C19.9226 17.4844 20.0009 17.0787 20.0376 16.6295C20.073 16.1955 20.073 15.6615 20.073 15.0085V14.978V11.4225V11.392C20.073 10.739 20.073 10.205 20.0376 9.77101C20.0009 9.32178 19.9226 8.91606 19.7295 8.53716C19.4274 7.94417 18.9452 7.46205 18.3522 7.1599C17.9733 6.96684 17.5676 6.88855 17.1184 6.85185C16.6844 6.81639 16.1504 6.8164 15.4974 6.81641H15.4669H8.67906ZM6.72402 8.36159C6.83357 8.33625 6.9698 8.31597 7.14604 8.30157C7.51381 8.27152 7.98821 8.27095 8.67906 8.27095H15.4669C16.1578 8.27095 16.6322 8.27152 17 8.30157C17.1762 8.31597 17.3124 8.33625 17.422 8.36159L14.1823 11.1963C13.7154 11.6048 13.3957 11.8839 13.1295 12.083C12.8706 12.2766 12.7059 12.3603 12.5634 12.4024C12.2433 12.4971 11.9027 12.4971 11.5826 12.4024C11.4401 12.3603 11.2754 12.2766 11.0165 12.083C10.7503 11.8839 10.4306 11.6048 9.96366 11.1963L6.72402 8.36159ZM5.64908 9.35377C5.60905 9.47958 5.57801 9.6465 5.55816 9.88945C5.52811 10.2572 5.52754 10.7316 5.52754 11.4225V14.978C5.52754 15.6689 5.52811 16.1433 5.55816 16.511C5.58751 16.8703 5.64134 17.0633 5.7125 17.203C5.8752 17.5223 6.1348 17.7819 6.45411 17.9446C6.59378 18.0157 6.78677 18.0696 7.14604 18.0989C7.51381 18.129 7.98821 18.1295 8.67906 18.1295H15.4669C16.1578 18.1295 16.6322 18.129 17 18.0989C17.3592 18.0696 17.5522 18.0157 17.6919 17.9446C18.0112 17.7819 18.2708 17.5223 18.4335 17.203C18.5047 17.0633 18.5585 16.8703 18.5878 16.511C18.6179 16.1433 18.6185 15.6689 18.6185 14.978V11.4225C18.6185 10.7316 18.6179 10.2572 18.5878 9.88945C18.568 9.6465 18.5369 9.47958 18.4969 9.35377L15.1402 12.2909L15.119 12.3095C14.6785 12.6949 14.3169 13.0113 14.0006 13.2478C13.672 13.4936 13.3494 13.6868 12.9759 13.7972C12.3866 13.9715 11.7594 13.9715 11.1701 13.7972C10.7966 13.6868 10.474 13.4936 10.1454 13.2478C9.82912 13.0113 9.46756 12.695 9.02705 12.3095L9.00583 12.2909L5.64908 9.35377Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <input
          className="input-invite-team"
          placeholder="you@example.com"
          value={data.email}
          onChange={handleInputChange}
        />
      </div>
      <div className="select-invite-team">
        <div className="icon-input-invite-team">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M15.3457 9.04368C15.3457 7.61203 14.1865 6.45277 12.7548 6.45277C11.3232 6.45277 10.1639 7.61203 10.1639 9.04368C10.1639 10.4753 11.3232 11.6346 12.7548 11.6346C14.1865 11.6346 15.3457 10.4753 15.3457 9.04368ZM16.9821 9.04368C16.9821 11.3791 15.0902 13.271 12.7548 13.271C10.4194 13.271 8.52754 11.3791 8.52754 9.04368C8.52754 6.70829 10.4194 4.81641 12.7548 4.81641C15.0902 4.81641 16.9821 6.70829 16.9821 9.04368ZM7.20936 18.5697C7.20936 19.2686 7.12685 19.18 7.51418 19.18H17.9955C18.3828 19.18 18.3003 19.2686 18.3003 18.5697C18.3003 16.8491 15.7746 15.8164 12.7548 15.8164C9.73499 15.8164 7.20936 16.8491 7.20936 18.5697ZM5.573 18.5697C5.573 15.5453 8.9119 14.18 12.7548 14.18C16.5977 14.18 19.9366 15.5453 19.9366 18.5697C19.9366 20.1475 19.3134 20.8164 17.9955 20.8164H7.51418C6.19621 20.8164 5.573 20.1475 5.573 18.5697Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <div className="form-select">
          <select>
            <option value="0">Choose role</option>
            <option value="1">Owner</option>
            <option value="2">Comment</option>
            <option value="3">View</option>
            <option value="4">Editor</option>
            <option value="5">Approve</option>
          </select>
          <div
            className={`selected-item ${data.role ? 'has-value' : 'is-placeholder'} ${isDropdown ? 'arrowanim' : ''}`}
            onClick={() => setIsDropdown((prev) => !prev)}
          >
            {data.role || 'Choose role'}
          </div>
          <div
            className="all-items all-items-hide"
            style={{ display: isDropdown ? 'block' : 'none' }}
          >
            {roleList.map((role, index) => (
              <div
                key={index}
                className="item-select"
                onClick={() => handleSelectChange(role)}
              >
                {role}
              </div>
            ))}
          </div>
        </div>
      </div>
      {!hideRemoveBtn && (
        <div className="btn-remove-team" onClick={() => onCardRemove(data.id)}>
          <svg
            width="18"
            height="20"
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 16C7.26522 16 7.51957 15.8946 7.70711 15.7071C7.89464 15.5196 8 15.2652 8 15V9C8 8.73478 7.89464 8.48043 7.70711 8.29289C7.51957 8.10536 7.26522 8 7 8C6.73478 8 6.48043 8.10536 6.29289 8.29289C6.10536 8.48043 6 8.73478 6 9V15C6 15.2652 6.10536 15.5196 6.29289 15.7071C6.48043 15.8946 6.73478 16 7 16ZM17 4H13V3C13 2.20435 12.6839 1.44129 12.1213 0.87868C11.5587 0.316071 10.7956 0 10 0H8C7.20435 0 6.44129 0.316071 5.87868 0.87868C5.31607 1.44129 5 2.20435 5 3V4H1C0.734784 4 0.48043 4.10536 0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5C0 5.26522 0.105357 5.51957 0.292893 5.70711C0.48043 5.89464 0.734784 6 1 6H2V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V6H17C17.2652 6 17.5196 5.89464 17.7071 5.70711C17.8946 5.51957 18 5.26522 18 5C18 4.73478 17.8946 4.48043 17.7071 4.29289C17.5196 4.10536 17.2652 4 17 4ZM7 3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H10C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V4H7V3ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V6H14V17ZM11 16C11.2652 16 11.5196 15.8946 11.7071 15.7071C11.8946 15.5196 12 15.2652 12 15V9C12 8.73478 11.8946 8.48043 11.7071 8.29289C11.5196 8.10536 11.2652 8 11 8C10.7348 8 10.4804 8.10536 10.2929 8.29289C10.1054 8.48043 10 8.73478 10 9V15C10 15.2652 10.1054 15.5196 10.2929 15.7071C10.4804 15.8946 10.7348 16 11 16Z"
              fill="#FF4359"
            />
          </svg>
        </div>
      )}
    </div>
  );
}

InviteTeamCard.defaultProps = {
  data: {},
  onFieldChange: () => {},
  onCardRemove: () => {},
  hideRemoveBtn: true,
};

export default InviteTeamCard;
